(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eh-classic-set-selector"] && !Shopify.designMode) return;
  try {
    const ehClassicOriginalGalleries = new WeakMap();
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-eh-classic-set], [data-eh-classic-mode], [data-eh-classic-cooler]');
    if (!button) return;
    const selector = button.closest('[data-eh-classic-selector]');
    const section = selector.closest('.eh-pdp-main');
    if (button.dataset.ehClassicSet) selector.dataset.set = button.dataset.ehClassicSet;
    if (button.dataset.ehClassicMode) selector.dataset.mode = button.dataset.ehClassicMode;
    if (button.dataset.ehClassicCooler) selector.dataset.cooler = button.dataset.ehClassicCooler;
    const set = selector.dataset.set;
    const cooler = selector.dataset.mode === 'no' ? 'no' : selector.dataset.cooler;
    const key = `${set}-${cooler}`;
    section.querySelectorAll('[data-eh-selection-guarantee]').forEach((element) => {
      element.textContent = cooler !== 'no' ? element.dataset.withCooler : element.dataset.base;
    });
    const gallery = section.querySelector('[data-eh-gallery]');
    const stage = gallery?.querySelector('.eh-pdp-main__stage');
    const thumbnails = gallery?.querySelector('.eh-pdp-main__thumbnails');
    if (stage && thumbnails) {
      if (!ehClassicOriginalGalleries.has(gallery)) {
        ehClassicOriginalGalleries.set(gallery, {
          slides: Array.from(stage.childNodes),
          thumbnails: Array.from(thumbnails.childNodes)
        });
      }
      const original = ehClassicOriginalGalleries.get(gallery);
      const bundleStage = gallery.querySelector('[data-eh-classic-gallery-stage="' + cooler + '"]');
      const bundleThumbnails = gallery.querySelector('[data-eh-classic-gallery-thumbnails="' + cooler + '"]');
      if (cooler !== 'no' && bundleStage && bundleThumbnails) {
        stage.replaceChildren(bundleStage.content.cloneNode(true));
        thumbnails.replaceChildren(bundleThumbnails.content.cloneNode(true));
      } else {
        stage.replaceChildren(...original.slides);
        thumbnails.replaceChildren(...original.thumbnails);
      }
      const firstSlide = stage.querySelector('[data-eh-gallery-slide]');
      stage.querySelectorAll('[data-eh-gallery-slide]').forEach((slide) => { slide.hidden = slide !== firstSlide; });
      thumbnails.querySelectorAll('[data-eh-gallery-thumb]').forEach((thumb) => {
        thumb.setAttribute('aria-selected', String(thumb.dataset.ehGalleryTarget === firstSlide?.dataset.ehGallerySlide));
      });
      thumbnails.scrollLeft = 0;
    }
    const data = selector.querySelector(`[data-eh-classic-data="${key}"]`).dataset;
    selector.querySelectorAll('[data-eh-classic-set], [data-eh-classic-mode], [data-eh-classic-cooler]').forEach((option) => {
      const selected = option.dataset.ehClassicSet ? option.dataset.ehClassicSet === set : option.dataset.ehClassicMode ? option.dataset.ehClassicMode === selector.dataset.mode : option.dataset.ehClassicCooler === selector.dataset.cooler;
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-checked', String(selected));
      option.tabIndex = selected ? 0 : -1;
    });
    selector.querySelector('[data-eh-classic-coolers]').hidden = cooler === 'no';
    const coolerData = ['mini', 'pro'].map((model) => ({model, data: selector.querySelector('[data-eh-classic-data="' + set + '-' + model + '"]').dataset}));
    const cheapest = coolerData.reduce((best, item) => Number(item.data.amount) < Number(best.data.amount) ? item : best);
    const from = selector.querySelector('[data-eh-cooler-from]');
    from.textContent = from.dataset.template.replace('__AMOUNT__', cheapest.data.price);
    coolerData.forEach(({model, data: optionData}) => {
      const row = selector.querySelector('[data-eh-classic-cooler="' + model + '"]');
      const total = row.querySelector('[data-eh-cooler-total]');
      total.textContent = optionData.price;
      total.classList.toggle('is-discounted', Boolean(optionData.compare));
      const comparison = row.querySelector('[data-eh-cooler-compare]');
      comparison.textContent = optionData.compare || '';
      comparison.hidden = !optionData.compare;
      const badge = row.querySelector('[data-eh-cooler-saving]');
      badge.textContent = optionData.saving ? selector.dataset.savingsLabel + ' ' + optionData.saving : '';
      badge.hidden = !optionData.saving;
    });
    section.querySelectorAll('[data-eh-classic-buy]').forEach((choice) => { choice.hidden = choice.dataset.ehClassicBuy !== key; });
    section.querySelectorAll('[data-eh-product-price], [data-eh-mobile-price]').forEach((element) => { element.textContent = data.price; });
    const compare = section.querySelector('[data-eh-product-compare]');
    compare.textContent = data.compare || '';
    compare.hidden = !data.compare;
    const saving = section.querySelector('[data-eh-product-saving]');
    saving.textContent = data.saving ? `${selector.dataset.savingsLabel} ${data.saving}` : '';
    saving.hidden = !data.saving;
    const mobileLabel = section.querySelector('[data-eh-mobile-label]');
    if (mobileLabel) mobileLabel.textContent = data.label;
    section.querySelectorAll('[data-eh-classic-gifts]').forEach((element) => { element.hidden = set !== 'accessories'; });
    section.querySelectorAll('klarna-placement').forEach((placement) => { placement.setAttribute('data-purchase-amount', data.amount); });
    if (window.Klarna?.OnsiteMessaging?.refresh) window.Klarna.OnsiteMessaging.refresh();
  });
  document.addEventListener('keydown', (event) => {
    const button = event.target.closest('[data-eh-classic-set], [data-eh-classic-mode], [data-eh-classic-cooler]');
    if (!button || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
    const options = Array.from(button.closest('[role="radiogroup"]').querySelectorAll('[role="radio"]:not(:disabled)'));
    let index = options.indexOf(button);
    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = options.length - 1;
    else index = (index + (['ArrowLeft','ArrowUp'].includes(event.key) ? -1 : 1) + options.length) % options.length;
    event.preventDefault();
    options[index].focus();
    options[index].click();
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-eh-combined-form]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.submitting === 'true') return;
    form.dataset.submitting = 'true';
    const button = form.querySelector('button[type="submit"]');
    const errorElement = form.querySelector('[data-eh-combined-error]');
    button.disabled = true;
    button.setAttribute('aria-busy','true');
    errorElement.hidden = true;
    try {
      const formData = new FormData(form);
      const items = [0,1].map((index) => ({ id: Number(formData.get(`items[${index}][id]`)), quantity: Number(formData.get(`items[${index}][quantity]`)) }));
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      if (!response.ok) throw new Error('Cart request failed');
      window.location.assign(`${root}cart`);
    } catch (error) {
      errorElement.hidden = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      delete form.dataset.submitting;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eh-cooler-options"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-eh-set-choice], [data-eh-classic-mode]');
    if (!choice) return;
    const selector = choice.closest('.eh-set-selector');
    if (!selector) return;
    const mode = choice.dataset.ehClassicMode || choice.dataset.ehSetChoice;
    selector.querySelectorAll('[data-eh-cooler-information]').forEach((element) => { element.hidden = mode !== 'yes'; });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eh-pro-cooler-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-eh-set-choice], [data-eh-cooler-choice]');
    if (!choice) return;
    const selector = choice.closest('[data-eh-pro-selector]');
    if (!selector) return;
    const section = selector.closest('.eh-pdp-main');
    if (choice.dataset.ehCoolerChoice) {
      selector.dataset.ehCooler = choice.dataset.ehCoolerChoice;
      selector.dataset.ehMode = 'yes';
    } else {
      selector.dataset.ehMode = choice.dataset.ehSetChoice;
    }
    const mode = selector.dataset.ehMode;
    const cooler = selector.dataset.ehCooler;
    const key = mode === 'yes' ? cooler : 'no';
    section.querySelectorAll('[data-eh-selection-guarantee]').forEach((element) => {
      element.textContent = mode === 'yes' ? element.dataset.withCooler : element.dataset.base;
    });
    const data = selector.querySelector('[data-eh-set-data="' + key + '"]').dataset;
    selector.querySelectorAll('[data-eh-set-choice], [data-eh-cooler-choice]').forEach((button) => {
      const selected = button.dataset.ehSetChoice ? button.dataset.ehSetChoice === mode : button.dataset.ehCoolerChoice === cooler;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-checked', String(selected));
      button.tabIndex = selected ? 0 : -1;
    });
    selector.querySelector('[data-eh-cooler-options]').hidden = mode !== 'yes';
    selector.querySelector('[data-eh-cooler-information]').hidden = mode !== 'yes';
    section.querySelectorAll('[data-eh-buy-choice]').forEach((form) => { form.hidden = form.dataset.ehBuyChoice !== key; });
    section.querySelectorAll('[data-eh-product-price], [data-eh-mobile-price]').forEach((element) => { element.textContent = data.price; });
    const mobileLabel = section.querySelector('[data-eh-mobile-label]');
    if (mobileLabel) mobileLabel.textContent = data.label;
    const compare = section.querySelector('[data-eh-product-compare]');
    if (compare) { compare.textContent = data.compare || ''; compare.hidden = !data.compare; }
    const saving = section.querySelector('[data-eh-product-saving]');
    if (saving) { saving.textContent = data.saving ? selector.dataset.ehSavingsLabel + ' ' + data.saving : ''; saving.hidden = !data.saving; }
    const gallery = section.querySelector('[data-eh-gallery]');
    const firstThumbnail = gallery.querySelector('[data-eh-gallery-thumb]');
    const target = mode === 'yes' ? 'set-' + cooler : firstThumbnail?.dataset.ehGalleryTarget;
    gallery.querySelectorAll('[data-eh-gallery-slide]').forEach((slide) => { slide.hidden = slide.dataset.ehGallerySlide !== target; });
    gallery.querySelectorAll('[data-eh-gallery-thumb]').forEach((thumb) => { thumb.setAttribute('aria-selected', String(mode === 'no' && thumb === firstThumbnail)); });
    section.querySelectorAll('klarna-placement').forEach((placement) => { placement.setAttribute('data-purchase-amount', data.amount); });
    if (window.Klarna?.OnsiteMessaging?.refresh) window.Klarna.OnsiteMessaging.refresh();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eh-video-testimonials"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eh-video-testimonials')) {
    customElements.define('eh-video-testimonials', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.initialize(); });
      }
      initialize() {
        if (this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('.eh-vt__track');
        this.slides = [...this.querySelectorAll('.eh-vt__slide')];
        this.dots = [...this.querySelectorAll('[data-index]')];
        this.status = this.querySelector('[data-status]');
        if (!this.track || !this.slides.length) return;
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.mobileOnly = this.dataset.mobileOnly === 'true';
        this.silent = this.dataset.silent === 'true';
        this.mobileQuery = matchMedia('(max-width: 749px)');
        this.inViewport = false;
        this.userPaused = new Set();
        this.pendingVideo = null;
        this.current = Math.min(this.slides.length - 1, Math.max(0, (Number(this.dataset.start) || 1) - 1));
        this.setAttribute('data-enhanced', '');
        this.querySelectorAll('video').forEach(video => {
          const card = video.closest('.eh-vt__card');
          const button = card.querySelector('.eh-vt__play');
          const sound = card.querySelector('.eh-vt__sound');
          video.controls = false;
          video.playsInline = true;
          if (this.autoplayEnabled || this.silent) {
            video.muted = true;
            video.defaultMuted = true;
            video.setAttribute('muted', '');
          }
          this.enforceSilent(video);
          video.setAttribute('aria-label', button.dataset.label);
          if (button.dataset.captionUrl) {
            video.crossOrigin = 'anonymous';
            const track = document.createElement('track');
            track.kind = 'captions';
            track.src = button.dataset.captionUrl;
            track.srclang = button.dataset.captionLang || 'de';
            track.label = track.srclang;
            track.default = true;
            video.append(track);
          }
          video.addEventListener('play', () => {
            if (this.mobileOnly && !this.mobileQuery.matches) { this.resetVideo(video); return; }
            this.enforceSilent(video);
            document.querySelectorAll('eh-video-testimonials video').forEach(other => { if (other !== video) other.pause(); });
            card.classList.add('is-playing');
            card.classList.toggle('is-interacting', !this.autoplayEnabled);
            video.controls = !this.autoplayEnabled;
            card.querySelector('.eh-vt__error').hidden = true;
            this.updateVideoButtons(video);
          }, { signal });
          video.addEventListener('pause', () => {
            if (this.autoplayEnabled) card.classList.remove('is-playing', 'is-interacting');
            this.updateVideoButtons(video);
          }, { signal });
          video.addEventListener('volumechange', () => { this.enforceSilent(video); this.updateVideoButtons(video); }, { signal });
          video.addEventListener('playing', () => card.classList.add('has-frame'), { signal });
          video.addEventListener('emptied', () => card.classList.remove('has-frame'), { signal });
          video.addEventListener('ended', () => this.resetVideo(video), { signal });
          video.addEventListener('error', () => { card.querySelector('.eh-vt__error').hidden = false; this.resetVideo(video); }, { signal });
          button.addEventListener('click', () => {
            const wasPlaying = !video.paused;
            this.userPaused.add(video);
            this.go(this.slides.indexOf(card.closest('.eh-vt__slide')), false);
            if (this.autoplayEnabled && wasPlaying) { this.resetVideo(video); return; }
            this.userPaused.delete(video);
            this.startVideo(video, false);
          }, { signal });
          if (sound) sound.addEventListener('click', () => {
            this.userPaused.add(video);
            this.go(this.slides.indexOf(card.closest('.eh-vt__slide')), false);
            video.muted = !video.muted;
            this.userPaused.delete(video);
            this.updateVideoButtons(video);
            if (video.paused) this.startVideo(video, false);
          }, { signal });
          this.updateVideoButtons(video);
        });
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.go(this.current + Number(button.dataset.step)), { signal }));
        this.dots.forEach(button => button.addEventListener('click', () => this.go(Number(button.dataset.index)), { signal }));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateNearest());
        }, { signal, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const index = event.key === 'ArrowRight' ? this.current + 1 : event.key === 'ArrowLeft' ? this.current - 1 : event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : null;
          if (index !== null) { event.preventDefault(); this.go(index); }
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const slide = this.slides.find(item => item.dataset.blockId === event.detail.blockId);
          if (slide && event.detail.sectionId === this.dataset.sectionId) this.go(this.slides.indexOf(slide), false);
        }, { signal });
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.pauseAll(); else this.syncAutoplay(); }, { signal });
        this.mobileQuery.addEventListener('change', () => {
          if (this.mobileOnly && !this.mobileQuery.matches) { this.inViewport = false; this.pauseAll(); }
          else this.go(this.current, false);
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.go(this.current, false));
        });
        this.resizeObserver.observe(this.track);
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.inViewport = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.15;
          if (this.inViewport) this.syncAutoplay(); else this.pauseAll();
        }, { threshold: [0, 0.15] });
        this.visibilityObserver.observe(this);
        this.go(this.current, false);
      }
      updateVideoButtons(video) {
        const card = video.closest('.eh-vt__card');
        const button = card.querySelector('.eh-vt__play');
        button.setAttribute('aria-label', this.autoplayEnabled && !video.paused ? button.dataset.pauseLabel : button.dataset.playLabel);
        const sound = card.querySelector('.eh-vt__sound');
        if (sound) {
          sound.dataset.muted = String(video.muted);
          sound.setAttribute('aria-label', video.muted ? sound.dataset.unmuteLabel : sound.dataset.muteLabel);
          sound.setAttribute('aria-pressed', String(!video.muted));
        }
      }
      enforceSilent(video) {
        if (!this.silent) return;
        if (!video.muted) video.muted = true;
        if (video.volume !== 0) video.volume = 0;
      }
      loadVideo(video) {
        if (!video.dataset.src || video.getAttribute('src')) return;
        const connection = navigator.connection;
        const slow = connection && (connection.saveData || ['slow-2g', '2g', '3g'].includes(connection.effectiveType));
        video.src = slow && video.dataset.lowSrc ? video.dataset.lowSrc : video.dataset.src;
        video.load();
      }
      startVideo(video, automatic) {
        if (this.mobileOnly && !this.mobileQuery.matches) return;
        this.enforceSilent(video);
        this.loadVideo(video);
        if (automatic) {
          video.muted = true;
          video.autoplay = true;
          this.pendingVideo = video;
        }
        video.controls = !this.autoplayEnabled;
        const playing = video.play();
        Promise.resolve(playing).catch(error => {
          if (error.name !== 'AbortError' && error.name !== 'NotAllowedError') video.closest('.eh-vt__card').querySelector('.eh-vt__error').hidden = false;
          this.resetVideo(video);
        }).finally(() => {
          if (this.pendingVideo === video) this.pendingVideo = null;
          if (automatic && this.slides[this.current]?.querySelector('video') !== video) this.syncAutoplay();
        });
      }
      syncAutoplay() {
        if (!this.autoplayEnabled) return;
        if (!this.inViewport || document.hidden || this.mobileOnly && !this.mobileQuery.matches) { this.pauseAll(); return; }
        const video = this.slides[this.current]?.querySelector('video');
        if (!video || this.userPaused.has(video) || !video.paused || this.pendingVideo) return;
        this.startVideo(video, true);
      }
      resetVideo(video, release = false) {
        video.autoplay = false;
        video.pause();
        video.controls = false;
        video.closest('.eh-vt__card').classList.remove('is-playing', 'is-interacting');
        this.updateVideoButtons(video);
        if (release && video.dataset.src && video.getAttribute('src')) {
          video.removeAttribute('src');
          video.closest('.eh-vt__card').classList.remove('has-frame');
          video.load();
        }
      }
      pauseAll() { this.querySelectorAll('video').forEach(video => this.resetVideo(video, true)); }
      go(index, smooth = true) {
        index = Math.min(this.slides.length - 1, Math.max(0, index));
        const rect = this.track.getBoundingClientRect();
        const slide = this.slides[index].getBoundingClientRect();
        this.track.scrollTo({ left: this.track.scrollLeft + slide.left + slide.width / 2 - rect.left - rect.width / 2, behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
        if (!smooth) this.setCurrent(index);
      }
      updateNearest() {
        const rect = this.track.getBoundingClientRect();
        const center = rect.left + rect.width / 2;
        let nearest = 0;
        let distance = Infinity;
        this.slides.forEach((slide, index) => {
          const bounds = slide.getBoundingClientRect();
          const offset = Math.abs(bounds.left + bounds.width / 2 - center);
          if (offset < distance) { distance = offset; nearest = index; }
        });
        this.setCurrent(nearest);
      }
      setCurrent(index) {
        this.current = index;
        this.slides.forEach((slide, position) => {
          slide.classList.toggle('is-active', position === index);
          if (position !== index) slide.querySelectorAll('video').forEach(video => this.resetVideo(video, true));
        });
        this.dots.forEach((dot, position) => { if (position === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        this.querySelectorAll('[data-step]').forEach(button => { button.disabled = Number(button.dataset.step) < 0 ? index === 0 : index === this.slides.length - 1; });
        this.status.textContent = this.status.dataset.template.replace('__NUMBER__', String(index + 1));
        this.syncAutoplay();
      }
      disconnectedCallback() {
        if (!this.abort) return;
        this.inViewport = false;
        this.pauseAll();
        this.abort.abort();
        this.abort = null;
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.resizeFrame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
